import { Component, OnInit } from '@angular/core';
import {
  AbstractFieldInputTypeHandlerComponent
} from '../../../../../../../../components/common/field/field-input/type-handler/abstract-field-input-type-handler.component';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {FormDefinitionFieldFindAllCachedService} from '../../../service/formDefinitionFieldFindAllCached.service';
import {FormValueModel} from '../../../../../../form/value/api/entity/formValue.model';

@Component({
  selector: 'app-report-component-label-default-value-value-rows-json-handler',
  templateUrl: './report-component-label-default-value-value-rows-json-handler.component.html',
})
export class ReportComponentLabelDefaultValueValueRowsJsonHandlerComponent
    extends AbstractFieldInputTypeHandlerComponent<UntypedFormArray>{

  constructor(private formBuilder: UntypedFormBuilder,
              private formDefinitionFieldFindAllCachedService: FormDefinitionFieldFindAllCachedService) {
    super();
    this.formDefinitionFieldFindAllCachedService.findAll();
  }

  buildJsonControl(): UntypedFormArray {
    return this.formBuilder.array([]);
  }

  synchronizeValue(): string {
    return '{ "rows": ' + JSON.stringify(this.jsonControl.value) + '}';
  }

  initiateForm(formValue: FormValueModel) {
    if (formValue?.value) {
      const rows: any[] = JSON.parse(formValue.value)['rows'];
      rows.forEach(row => {
        const control = this.newRow();
        control.patchValue(row);
        this.jsonControl.push(control);
      });
      // console.log(['initiateForm', rows]);
      this.jsonControl.patchValue(rows);
    }
  }


  newRow = (): UntypedFormGroup => {
    return this.formBuilder.group({
      label: new UntypedFormControl(undefined, Validators.required),
      defaultValue: new UntypedFormControl(undefined),
      formDefinitionFieldName: new UntypedFormControl(undefined, Validators.required),
    });
  }
}
